import React, { useEffect, useState } from 'react';
import { changeDateForMilliSecondsWithType } from 'js/library/utils/helpers';
import { toast } from 'react-toastify';
import { downloadImage, downloadImageAsBlob } from 'js/library/services/StorageManager';
import services from './ListOfUsers/services';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

// Styles
import { Button, CircularProgress, Grid, TextField, Typography } from '@mui/material';

// Components
import { ListOfUsers } from './ListOfUsers/ListOfUsers';
import { ModalBudgetSummary } from './ModalBudgetSummary';
import { OutlinedInput } from 'js/components/TriiboComponents/Input/OutlinedInput';
import { PageStructure } from 'js/components/TriiboComponents/PageStructure/PageStructure';
import { StandardSelect } from 'js/components/TriiboComponents/Select/StandardSelect';

// Apis
import { createCommunicationMessage } from 'js/library/utils/API/createCommunicationMessage';
import { generateQuote } from 'js/library/utils/API/generateQuote';
import { getUsersByFile } from 'js/library/utils/API/getUsersByFile';
import { getUsersByPartner } from 'js/library/utils/API/apiGetUsersByPartner';
import { uploadFiles } from 'js/library/utils/API/apiUploadFiles';

const boxStyle = {
  background: '#fff',
  border: '1px solid #70707033',
  borderRadius: '5px',
  boxShadow: '0px 3px 6px #00000029',
  padding: '30px 30px',
  width: '7 0%',
};

export const NewQuoteMessage = () => {
  const partnerIdClube = localStorage.getItem('partnerIdClube');
  const location = useLocation();
  const { userPoints } = location.state;

  // const typeOptions = [/* 'email', */ 'sms' /* , 'whatsapp' */];

  const [arrayDataToTxt, setArrayDataToTxt] = useState(null);
  const [budgetResume, setBudgetResume] = useState({});
  const [communicationData, setCommunicationData] = useState({
    title: '',
    message: '',
    partnerId: partnerIdClube,
    scheduleDate: '',
  });
  const [checkedItems, setCheckedItems] = useState({
    item1: false,
    item2: false,
  });
  const [clubKey, setClubKey] = useState('');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalBudgetIsOpen, setModalBudgetIsOpen] = useState(false);
  const [quoteData, setQuoteData] = useState({
    quotationsToMake: { sms: true },
    filePath: '',
  });

  useEffect(() => {
    services.getClubToken(partnerIdClube, setClubKey);
  }, []);

  const createNewBudget = async () => {
    setLoading(true);

    if (!checkedItems.item1 && !checkedItems.item2) {
      toast.warning('Selecione ao menos uma opção de lista de envio.');
      setLoading(false);
      return;
    }

    if (checkedItems.item2 && data.length === 0) {
      toast.warning('Para continuar, inclua pelo menos um usuário que receberá a mensagem.');
      setLoading(false);
      return;
    }

    const now = new Date();
    const actualDate = new Date(communicationData.scheduleDate);

    if (communicationData.scheduleDate && actualDate < now) {
      toast.warning('A data de envio não pode ser anterior à data atual.');
      setLoading(false);
      return;
    }

    try {
      const fileTxt = await mergeKeysAndUpload();

      if (!fileTxt) {
        setLoading(false);
        return toast.warning('Não foi possível gerar o arquivo com os usuários.');
      }

      const communicationPayload = {
        ...communicationData,
        scheduleDate: communicationData.scheduleDate
          ? changeDateForMilliSecondsWithType(null, communicationData.scheduleDate)
          : null,
      };

      const communicationMessageId = await createCommunicationMessage(communicationPayload);

      const quotePayload = {
        filePath: fileTxt,
        communicationMessageId,
        quotationsToMake: quoteData.quotationsToMake,
      };

      const resumeQuote = await generateQuote(quotePayload);
      setBudgetResume({ resumeQuote, communicationMessageId });

      toast.success('Mensagem criada com sucesso!');
      setCommunicationData({
        title: '',
        message: '',
        partnerId: partnerIdClube,
        scheduleDate: null,
      });
      setQuoteData({ quotationsToMake: [], filePath: '' });
      handleModalBudget();
    } catch (e) {
      toast.error('Algo não funcionou corretamente, tente novamente mais tarde.');
      console.log('ERROR when generating a new budget ==>', e);
    } finally {
      setLoading(false);
    }
  };

  const extractKeyFromUser = (user, clubKey) => {
    switch (clubKey) {
      case 'uid':
        return user.uid;
      case 'cpf':
        return user.documentList?.find((d) => d.type === 'cpf')?.value;
      case 'doc':
        return user.documentList?.find((d) => d.type === 'doc')?.value;
      case 'cellPhone':
        return user.contactList?.find((c) => c.type === 'cellPhone')?.value;
      case 'email':
        return user.contactList?.find((c) => c.type === 'email')?.value;
      default:
        return user[clubKey];
    }
  };

  const formatToLocalISO = (date) => {
    const localDate = new Date(date);
    localDate.setMinutes(localDate.getMinutes() - localDate.getTimezoneOffset());
    return localDate.toISOString().slice(0, 16);
  };

  const getCurrentISO = () => {
    const now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
    return now.toISOString().slice(0, 16);
  };

  const handleInputs = (value, label) => {
    switch (label) {
      // TRATA SELECTS
      case 'Identificador da mensagem':
        setCommunicationData((prevCommunication) => ({ ...prevCommunication, title: value }));
        break;
      case 'Digite sua mensagem':
        setCommunicationData((prevCommunication) => ({ ...prevCommunication, message: value }));
        break;
      default:
        break;
    }
  };

  const handleModalBudget = () => {
    setModalBudgetIsOpen(!modalBudgetIsOpen);
  };

  const maxCharactersForChannel = () => {
    const channel = Object.keys(quoteData.quotationsToMake)[0];
    switch (channel) {
      case 'email':
        return 4000;
      case 'sms':
        return 160;
      case 'whatsapp':
        return 4000;
      default:
        return 0;
    }
  };

  const mergeKeysAndUpload = async () => {
    let allKeys = [];
    let usersNotFound = [];

    if (checkedItems.item1) {
      try {
        const listUsers = await getUsersByPartner(partnerIdClube);
        const keysFromPartner = listUsers
          .map((user) => extractKeyFromUser(user, clubKey))
          .filter(Boolean);
        allKeys.push(...keysFromPartner);
      } catch (e) {
        console.error('Erro ao buscar usuários do clube:', e);
      }
    }

    // 2. Usuários do arquivo
    if (arrayDataToTxt && checkedItems.item2) {
      try {
        const path = await uploadingFile(arrayDataToTxt);

        const payload = {
          filePath: path,
          fileFolderName: 'file-users-to-messages',
          partnerId: partnerIdClube,
        };

        if (arrayDataToTxt.type === 'text/plain' || arrayDataToTxt.type === 'text/csv') {
          const response = await getUsersByFile(payload);
          usersNotFound = response.usersNotFound?.filter((user) => user !== clubKey) || [];

          if (response.fileOutputPath) {
            const splitIndex = response.fileOutputPath.lastIndexOf('/');
            const filePath = response.fileOutputPath.substring(0, splitIndex);
            const nameFile = response.fileOutputPath.substring(splitIndex + 1);
            const downloadedFile = await downloadImage(filePath, nameFile);

            const fileAsBlob = await downloadImageAsBlob(downloadedFile);
            const fileContent = await readFileContent(fileAsBlob);

            const extractedKeys = fileContent
              .trim()
              .split('\n')
              .map((line) => line.split(';')[1].trim())
              .filter((line) => line.toLowerCase() !== clubKey && line !== '');
            allKeys.push(...extractedKeys);
          }
        } else {
          toast.error('O arquivo precisa ser no formato txt ou csv!', { autoClose: 2500 });
          setArrayDataToTxt(null);
        }
      } catch (error) {
        toast.error('Erro ao fazer upload do arquivo!', { autoClose: 2500 });
      }
    }

    // 3. Eliminar duplicados
    const uniqueKeys = [...new Set(allKeys)];

    // 4. Mostrar erro se tiver usuários inválidos
    if (usersNotFound.length > 0) {
      toast.error(
        `Esses usuários não serão notificados, pois não são membros do clube: ${usersNotFound.join(
          ', '
        )}`,
        { autoClose: 2500 }
      );
    }

    if (uniqueKeys.length === 0) return null;
    const finalContent = `token\n${uniqueKeys.join('\n')}`;
    const finalBlob = new Blob([finalContent], { type: 'text/plain' });
    const finalFile = new File([finalBlob], 'usuarios.txt', { type: 'text/plain' });

    try {
      const filePath = await uploadingFile(finalFile);
      return filePath;
    } catch (e) {
      console.error('Erro ao enviar arquivo final:', e);
      return null;
    }
  };

  const readFileContent = (fileBlob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => resolve(e.target.result);
      reader.onerror = (err) => reject(err);
      reader.readAsText(fileBlob);
    });
  };

  const uploadingFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        const base64String = btoa(String.fromCharCode(...new Uint8Array(reader.result)));

        uploadFiles('file-users-to-messages', {
          mimeType: file.type,
          fileName: file.type === 'text/plain' ? 'usuarios.txt' : 'usuarios.csv',
          buffer: base64String,
        })
          .then((res) => {
            const response = res.split('/');
            const path = 'file-users-to-messages/' + response[response.length - 1].split('?')[0];
            resolve(path);
          })
          .catch((err) => {
            reject('');
          });
      };

      reader.onerror = () => {
        reject('');
      };

      reader.readAsArrayBuffer(file);
    });
  };

  return (
    <PageStructure title="Nova comunicação">
      <Grid container spacing={2} sx={boxStyle}>
        <Grid item md={12} xs={12}>
          <TextField
            fullWidth
            id="notificationDate"
            label="Selecione data e hora em que a mensagem será disparada:"
            type="datetime-local"
            value={
              communicationData.scheduleDate ? formatToLocalISO(communicationData.scheduleDate) : ''
            }
            onChange={(e) =>
              setCommunicationData((prevCommunication) => ({
                ...prevCommunication,
                scheduleDate: e.target.value,
              }))
            }
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              min: getCurrentISO(),
            }}
            color="primary"
            required
          />
        </Grid>
        {/*  <Grid item md={6} xs={12}>
          <StandardSelect
            label="Selecione os canais de comunicação"
            menuOptions={typeOptions}
            setValue={(e) =>
              setQuoteData((prevQuote) => ({
                ...prevQuote,
                quotationsToMake: { [e]: true },
              }))
            }
            value={Object.keys(quoteData.quotationsToMake)[0] || ''}
            width={'100%'}
          />
        </Grid> */}
        <Grid item md={12} xs={12}>
          <OutlinedInput
            label="Identificador da mensagem"
            fullWidth
            setValue={handleInputs}
            value={communicationData.title}
          />
        </Grid>
        <Grid item md={12} xs={12}>
          <OutlinedInput
            disabled={quoteData.quotationsToMake === ''}
            label="Digite sua mensagem"
            fullWidth
            maxLength={maxCharactersForChannel(quoteData.quotationsToMake)}
            multiline
            rows={3}
            maxLe
            setValue={handleInputs}
            value={communicationData.message}
          />
          <Typography
            sx={{ display: 'flex', justifyContent: 'flex-end', marginRight: '0.6rem' }}
            variant="caption"
          >
            {communicationData.message.length}/
            {quoteData.quotationsToMake ? maxCharactersForChannel(quoteData.quotationsToMake) : 0}{' '}
            caracteres
          </Typography>
        </Grid>
        <Grid item md={12} xs={12}>
          <ListOfUsers
            setArrayDataToTxt={setArrayDataToTxt}
            checkedItems={checkedItems}
            setCheckedItems={setCheckedItems}
            data={data}
            setData={setData}
          />
        </Grid>

        <Grid item md={12} xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            disabled={
              loading ||
              communicationData.scheduleDate === null ||
              communicationData.title === '' ||
              communicationData.message === '' ||
              quoteData.quotationsToMake === ''
            }
            onClick={createNewBudget}
            variant="contained"
            sx={{ minWidth: '13rem' }}
          >
            {loading ? (
              <CircularProgress size={23} thickness={6} sx={{ color: '#fff' }} />
            ) : (
              'Salvar e gerar orçamento'
            )}
          </Button>
        </Grid>
      </Grid>
      <ModalBudgetSummary
        budgetResume={budgetResume}
        close={handleModalBudget}
        open={modalBudgetIsOpen}
        userPoints={userPoints}
      />
    </PageStructure>
  );
};
